<template>
  <el-dialog class="repassword-private"
             :visible.sync="show"
             :title="$t('privateNetInstance.repasswordTip')"
             :close-on-click-modal="false"
             :before-close="handleClose">
    <p>{{ $t('privateNetInstance.operations.onlySubmit') }}</p>
    <div slot="footer" class="dialog-footer">
      <el-button @click="cancel">{{ $t('privateNetInstance.cancel') }}</el-button>
      <el-button @click="submit" type="primary">{{ $t('privateNetInstance.submit') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
  export default {
    name: "Repassword",
    props: {
      visible: {
        type: Boolean,
        default: false
      },
    },
    data() {
      return {
        show: false
      }
    },
    methods: {
      handleClose() {
        this.show = false;
        this.$emit('update:visible', false);
      },
      cancel() {
        this.handleClose();
      },
      submit() {
        //TODO 跳转到somewhere
      },
    },
    watch: {
      visible(newVal) {
        this.show = newVal;
      }
    }
  }
</script>

<style lang="scss">
  .repassword-private{

  }
</style>




// WEBPACK FOOTER //
// src/components/privateNetInstance/operates/Repassword.vue